export default __webpack_public_path__ + "static/media/removeIcon.b8936e15.webp";